import { t } from 'i18next'
import React, { useEffect } from 'react'
import { getGlobalSettingValue } from '../../services/common/utils'
import { useSelector } from 'react-redux';

const WifiHeader = ({setIconFlag, iconFlag, logout}) => {
  const {
    utilityData: {
      globalSetting,
    }
  } = useSelector((state) => state);
  const settingsArr = globalSetting
  ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
  : [];
  useEffect(() => {
    if(getGlobalSettingValue('wifitakeoverpopuptimer',settingsArr)){
      setTimeout(() => {
        setIconFlag(!iconFlag)
      }, getGlobalSettingValue('wifitakeoverpopuptimer',settingsArr) * 1000);    
    }
   
  }, [])
console.log(getGlobalSettingValue('wifitakeoverpopuptimer',settingsArr), "getGlobalSettingValue('wifitakeoverpopuptimer') * 1000")
  return (
    <div
    className="header_container flex_grp_center wifi-main-header"  onClick={() =>setIconFlag(!iconFlag)} 
    style={{  padding : '0px'}} 
  >      <div class="header_wifi" style={{width:'100%'}}>
            <div >
                <img className='wifi-header-img' src={process.env.PUBLIC_URL + '/assets/images/wifi_blue_icon.svg'} alt="" title="" class="rounded-circle" />
                <label class="ms-2" dir='ltr'>{t("litwfn")}</label>
            </div>
            <div class="pointer logout-icon-comp" onClick={() => logout()}>
                <img src={process.env.PUBLIC_URL + '/assets/images/logout_icon.svg'} alt="" title="" />
                <label class="ms-1">{t("logout")}</label>
            </div>
        </div>
        </div>
  )
}

export default WifiHeader